import { render, staticRenderFns } from "./ConfirmDeleteTabItemForm.vue?vue&type=template&id=09789a85&"
import script from "./ConfirmDeleteTabItemForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteTabItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports